import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';
import SelectField from '../../Forms/Input/SelectField';

import useCashDrawer from '../../../hooks/hardware/useCashDrawer';
import usePrinter from '../../../hooks/hardware/usePrinter';

import {
  closeRegistrationModalAndReset,
  updateCashDrawerField,
} from '../../../store/slices/hardware/cashDrawerSlice';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}

const CashDrawerRegistrationPopup: React.FC<Props> = ({ isOpen, onSave }) => {
  const dispatch = useDispatch();
  const { form } = useCashDrawer();
  const { list: printers, fetchAllPrinters } = usePrinter();

  useEffect(() => {
    if (isOpen) {
      fetchAllPrinters(); // 🔄 Cargar lista de impresoras
    }
  }, [isOpen]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    const parsedValue = name === 'printerId' ? Number(value) : value;

    dispatch(updateCashDrawerField({ field: name as any, value: parsedValue }));
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={() => dispatch(closeRegistrationModalAndReset())}
      title="Registrar Cajón de Dinero"
      maxWidth="max-w-3xl"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}
        className="grid grid-cols-1 gap-4 md:grid-cols-2"
      >
        {/* Nombre del Cajón */}
        <InputField
          label="Nombre del Cajón"
          name="name"
          iconKey="list"
          value={form.name}
          onChange={handleChange}
          type="text"
        />

        {/* Impresora Asociada */}
        <SelectField
          label="Impresora"
          name="printerId"
          iconKey="printer"
          value={form.printerId ?? ''}
          onChange={handleChange}
          options={printers.map((printer) => ({
            label: printer.name,
            value: printer.id,
          }))}
          placeholder="Seleccione impresora"
        />

        {/* Comando de Apertura */}
        <InputField
          label="Comando de Apertura"
          name="openCommand"
          iconKey="code"
          value={form.openCommand}
          onChange={handleChange}
          type="text"
        />

        {/* Botón Guardar */}
        <div className="md:col-span-2">
          <button
            type="submit"
            className="w-full rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
          >
            Guardar Cajón
          </button>
        </div>
      </form>
    </FormModal>
  );
};

export default CashDrawerRegistrationPopup;
